module.exports = __webpack_public_path__ + "img/starss.60137762.png";